import * as Yup from "yup";

import { AccountType, RegistryCode } from "@/app/types/generated/graphql";

/**
 * Validation Schema for Linked Registry
 */
export const registrySchema = Yup.object().shape({
  status: Yup.string().oneOf(["REGISTERED", "PENDING"]),
});

export const multipleLinkRegistrySchema = Yup.object().shape({
  registryId: Yup.string().required("Required"),
  //Type is required for MRETS; for ERCOT, it’s auto-calculated from accountNumber on submit.
  type: Yup.string().when("registryCode", {
    is: RegistryCode.Mrets,
    then: Yup.string().nullable().required("Required"),
    otherwise: Yup.string().nullable().notRequired(),
  }),
  //accountNumber is required if type is Registry and registryCode is Mrets
  accountNumber: Yup.string().when(["type", "registryCode"], {
    is: (type: AccountType, registryCode: RegistryCode) =>
      type === AccountType.Registry && registryCode === RegistryCode.Mrets,
    then: Yup.string().required("Required"),
    otherwise: Yup.string().nullable().notRequired(),
  }),
  //nrmTermsAccepted required if registryCode is Ercot(always) or Mrets with NonRegistry type.
  nrmTermsAccepted: Yup.boolean().when(["type", "registryCode"], {
    is: (type: AccountType, registryCode: RegistryCode) =>
      (registryCode === RegistryCode.Mrets && type === AccountType.NonRegistry) || registryCode === RegistryCode.Ercot,
    then: Yup.boolean().oneOf([true], "You must accept the terms"),
    otherwise: Yup.boolean().notRequired(),
  }),
});
